/* global axios */
import ApiClient from './ApiClient';

class TasksAPI extends ApiClient {
  constructor() {
    super('tasks', { accountScoped: true });
  }

  /**
   * Obtiene todas las tareas de forma optimizada
   * @returns {Promise} - Promesa con las tareas
   */
  getTasks() {
    return axios.get(this.url);
  }
}

export default new TasksAPI();
